/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartGantt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-chart-gantt_svg__st0{fill:currentcolor}'}</style>
    <path className="ico-chart-gantt_svg__st0" d="M4 6h6V4H4V2H2v20h20v-2H4z" />
    <path
      className="ico-chart-gantt_svg__st0"
      d="M11 4h6v2h-6zM6 8h7v2H6zm8 0h4v2h-4zm-6 4h14v2H8zm-2 4h4v2H6zm5 0h8v2h-8z"
    />
  </Icon>
);
export { SvgChartGantt as ChartGantt };
